export default class OtpAutofillUtil {
    /**
     * WebOTP only applies to standard SMS delivery (not voice, email, or WhatsApp).
     */
    static isSmsOtpType(destinationProtocol) {
        return destinationProtocol === 'SMS';
    }

    /**
     * Requests an OTP from the browser WebOTP API when supported.
     * Requires origin-bound SMS formatting and Permissions-Policy: otp-credentials=(self)
     * on the navigation document that loaded this page (not on XHR/fetch responses).
     */
    static requestWebOtp({ onOtpReceived, signal }) {
        if (!('OTPCredential' in window) || !navigator.credentials) {
            return;
        }

        navigator.credentials
            .get({
                otp: { transport: ['sms'] },
                signal,
            })
            .then((otpCredential) => {
                // Abort after resolve is a no-op on the settled promise; skip the
                // callback so unmounted OTP UI cannot push into the store.
                if (signal.aborted) {
                    return;
                }
                if (otpCredential && otpCredential.code) {
                    onOtpReceived(otpCredential.code);
                }
            })
            .catch(() => {
                // User dismissed the prompt, timed out, aborted, or WebOTP is unavailable.
            });
    }
}
